import { LegalContact } from "@omni/types/api/product/bff/shared/legalContact.model";
import { cn } from "@omni/utils/styles";

import { PhoneNumber } from "@/components/General/PhoneNumber/phoneNumber.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type LegalContactComponentProps = {
    contact: LegalContact;
};

const LegalContactComponent = ({ contact }: LegalContactComponentProps) => {
    const { t } = useGranite();
    return (
        <>
            <div>{t(`product.legalContacts.type.${contact.type}`)}</div>
            <address className={cn("tw:m-0")}>
                {contact.name.length > 0 && (
                    <div>
                        {contact.name.map((n) => (
                            <span key={n}>{n}</span>
                        ))}
                    </div>
                )}
                {contact.address.length > 0 && (
                    <div>
                        {contact.address.map((w) => (
                            <div key={w}>{w}</div>
                        ))}
                    </div>
                )}
                {contact.email.length > 0 && (
                    <div>
                        {contact.email.map((w) => (
                            <a
                                key={w}
                                href={`mailto:${w}`}
                            >
                                {w}
                            </a>
                        ))}
                    </div>
                )}
                {contact.phone.length > 0 && (
                    <div>
                        {contact.phone.map((p) => (
                            <div key={p}>
                                <PhoneNumber
                                    phoneNumber={p}
                                    asLink={true}
                                />
                            </div>
                        ))}
                    </div>
                )}
                {contact.fax.length > 0 && (
                    <div>
                        {contact.fax.map((p) => (
                            <div key={p}>
                                <PhoneNumber
                                    phoneNumber={p}
                                    asLink={true}
                                />
                            </div>
                        ))}
                    </div>
                )}
                {contact.website.length > 0 && (
                    <div>
                        {contact.website.map((w) => (
                            <span key={w}>{w}</span>
                        ))}
                    </div>
                )}
                {contact.mobileWebsite.length > 0 && (
                    <div>
                        {contact.mobileWebsite.map((w) => (
                            <span key={w}>{w}</span>
                        ))}
                    </div>
                )}
                {contact.socialMedia.length > 0 && (
                    <div>
                        {contact.socialMedia.map((w) => (
                            <span key={w}>{w}</span>
                        ))}
                    </div>
                )}
                {contact.freePhone.length > 0 && (
                    <div>
                        {contact.freePhone.map((p) => (
                            <div key={p}>
                                <PhoneNumber
                                    phoneNumber={p}
                                    asLink={true}
                                />
                            </div>
                        ))}
                    </div>
                )}
            </address>
        </>
    );
};

export { LegalContactComponent };
